import { IConfig } from "./Render";
export const Path = ({extraProps}:IConfig)=>
{   
    return (
           <path fill={extraProps.fill} stroke={extraProps.stroke} d={extraProps.d}
            fillOpacity={extraProps.fillOpacity} strokeWidth={extraProps.strokeWidth} 
            strokeDasharray={extraProps.strokeDashArray} 
            key={extraProps.key}></path>      
    );
}